export const AzureADApplicationsTooltip = () => (
  <>
    AzureAD applications from Bayer tenant which can access Data Domains storage buckets using
    their Service Principal token.
  </>
);
